import AquaHeader from './AquaHeader'
import CanvasHeader from './CanvasHeader'

function Header({
  theme,
  setTheme,
  resolvedTheme,
  designLanguage,
  setDesignLanguage,
}) {
  const nextDesignLanguage =
    designLanguage === 'material3' ? 'liquid-glass' : 'material3'

  const props = {
    theme,
    setTheme,
    resolvedTheme,
    nextDesignLanguage,
    setDesignLanguage,
  }

  return designLanguage === 'material3' ? (
    <CanvasHeader {...props} />
  ) : (
    <AquaHeader {...props} />
  )
}

export default Header
